import { Project } from './../models/Project.model';
import { Result } from "./../models/Result.model";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { HttpClient } from "../shared/wrappers/HttpClient";
import { UrlBuilder } from "../models/url-builder.model";
import { Refund } from '../models/Refund.model';
import { RefundBilling } from '../models/billing-letter/Refund.model';

@Injectable()
export class RefundsService {
    constructor(private httpClient: HttpClient) {}

    endPoint: String = "/refunds";

    async getAll(queryString) {
        return await this.httpClient.get(`${this.endPoint}?${queryString}`);
    }

    async getRefund(id): Promise<Refund> {
        return await this.httpClient.get(`${this.endPoint}/${id}`);
    }

    async update(refund: Refund) {
        return await this.httpClient.update(
            this.endPoint,
            refund._id,
            refund
        );
    }

    async approval(refund: Refund): Promise<Refund> {
        return await this.httpClient.post(`${this.endPoint}/${refund._id}/approval`, refund);
    }

    async getProjectCustomersStatus(){
        return await this.httpClient.get(`${this.endPoint}/filters`);
    }

    async getRefundsByGroupId(id): Promise<any[]> {
        return await this.httpClient.get(`${this.endPoint}/group/${id}`);
    }

    async getSapDocNumByRefund(sapDocEntry: String) {
        return await this.httpClient.get(`/purchase-orders/sap/${sapDocEntry}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/refund.service.ts